import { IonContent, IonPage, IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { RouteChildrenProps, useParams } from 'react-router';
import { Machine, useGetMachineQuery } from '../../api/graphql/generated';
import { NestedPageHeader } from '../../components/header/page.header';
import { MachineFiles } from '../../components/machine/machine-files';
import { MachineProgramStatus } from '../../components/machine/machine-program-status';
import { useBeaconRouter } from '../../route/route.hooks';
import { useQueryParameters } from '../../util/router';

interface RouteParams {
  id: string;
  fileId?: string;
}

interface MachineFilesPageProps extends RouteChildrenProps {
  teamId: string;
}

const MachineFilesPage = (props: MachineFilesPageProps): ReactElement => {
  const { teamId } = props;

  const params = useParams<RouteParams>();
  const { id } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id, teamId } },
  });
  const queryParams = useQueryParameters();
  const { builder } = useBeaconRouter();

  const path = queryParams.get('path');

  const machine: Machine | undefined = data?.getMachine;
  return (
    <IonPage>
      <NestedPageHeader defaultBackRoute={builder.getMachineRoute(teamId, id)}>
        <IonTitle>
          {machine?.name}
          <div className="subtitle header-program-status">
            <MachineProgramStatus machine={machine} />
          </div>
        </IonTitle>
      </NestedPageHeader>
      <IonContent>
        <MachineFiles machine={machine} filesPath={path} />
      </IonContent>
    </IonPage>
  );
};

export { MachineFilesPage };
